var carousel = document.getElementById('carousel');
var prevBtn = document.getElementById('prevBtn');
var nextBtn = document.getElementById('nextBtn');
var scrollTimeout;
var autoplayTimeout;
var videoDurationTimeout;
var isUserInteracting = false;
var originalVideosCount = 0;
var videosLoaded = false;
var currentlyPlayingCard = null;
var carouselShimmer = carousel.innerHTML;

function getVideoThumbnailUrl(url) {
    if (!url) return url;

    return url.replace("output.m3u8", "thumbnail.jpeg");

}

function isMobile() {
    return window.innerWidth <= 768;
}

function stopAllVideos() {
    var allCards = carousel.querySelectorAll('.video-card');
    allCards.forEach(function (card) {
        var videoEl = card.querySelector('video');
        var imgEl = card.querySelector('.thumbnail-img');
        if (videoEl) {
            videoEl.pause();
            videoEl.style.display = 'none';
            imgEl.style.display = 'block';
        }
    });
    currentlyPlayingCard = null;
}

function showVideos(videos) {
    if (!videos || videos.length === 0) {
        document.getElementById('videoCarouselContainer').style.display = 'none';
        return;
    }

    // Clear shimmer placeholders before appending real cards
    carousel.innerHTML = '';

    originalVideosCount = videos.length;

    for (var i = 0; i < videos.length; i++) {
        var video = videos[i];
        var card = document.createElement('div');
        card.className = 'video-card';
        card.setAttribute('data-ad-url', video.AdUrl || "#");
        card.setAttribute('data-video-index', i);

        var thumbnailUrl = getVideoThumbnailUrl(video.PrimaryImage?.Url || "");

        var html = '<img src="'
            + thumbnailUrl
            + '" alt="' + video.TitleSeo
            + '" class="thumbnail-img" '
            + 'onerror="this.onerror=null;this.src=\'/Content/Images/dark-skeleton-animated.svg\';">';

        var videoUrl = video.PrimaryImage?.Url || "";

        html += '<video muted playsinline preload="metadata" style="display:none;" '
            + 'data-src="' + videoUrl + '" '
            + 'poster="' + thumbnailUrl + '">'
            + (i < 3 && videoUrl ? '<source src="' + videoUrl + '" type="application/vnd.apple.mpegurl">' : '')
            + '</video>';

        html += '<div class="video-info">';

        if (video.StoreLogoTitle || video.StoreName) {

            html += '<div class="video-store-row">';

            if (video.StoreLogoTitle) {
                html += '<img src="'
                    + video.StoreLogoUrl
                    + '" class="video-store-logo">';
            }

            html += '<div class="video-store-name">'
                + (video.StoreName || '')
                + '</div>';

            html += '</div>';
        }

        html += '<div class="video-item-title">' + video.Title + '</div>';

        if (video.HasPrice){
            html += '<div class="video-item-price">'
                + video.Currency + " " + video.Price
                + '</div>';
        }

        html += '</div>';

        html += '<div class="video-item-title">' + video.Title + '</div>';
        if (video.HasPrice){
            html += '<div class="video-item-price">' + video.Currency + " " + video.Price + '</div>';
        }
        html += '</div>';

        card.innerHTML = html;
        carousel.appendChild(card);

        card.addEventListener('mouseenter', (function (currentCard) {
            return function () {
                isUserInteracting = true;
                clearTimeout(autoplayTimeout);
                clearTimeout(videoDurationTimeout);

                if (isPlaying(currentCard)) return;

                // Stop any currently playing video
                stopAllVideos();

                var videoEl = currentCard.querySelector('video');
                var imgEl = currentCard.querySelector('.thumbnail-img');

                if (videoEl) {
                    prepareVideo(videoEl, true);

                    currentlyPlayingCard = currentCard;
                    videoEl.style.display = 'block';
                    imgEl.style.display = 'none';
                    videoEl.currentTime = 0;
                    videoEl.play();
                    // Cap at 10 seconds for hover playback
                    videoDurationTimeout = setTimeout(function () {
                        videoEl.pause();
                    }, 10000);
                }
            };
        })(card));

        card.addEventListener('mouseleave', function () {
            // On mouseleave, replay the first item in viewport
            autoplayFirstVisibleCard();
        });
    }

    // Autoplay the first visible card on initial load - when the page is idle
    var startAutoplay = function () {
        requestAnimationFrame(function () {
            autoplayFirstVisibleCard();
        });
    };

    if (document.readyState === 'complete') {
        startAutoplay();
    } else {
        window.addEventListener('load', startAutoplay);
    }

    videosLoaded = true;
    updateNavButtons();
}

if (window.videoFeed) {
    showVideos(window.videoFeed);
}
else {
    $.ajax({
        url: window.pzVideoFeedUrl,
        type: 'GET',
        dataType: 'json',
        success: function (videos) {
            window.videoFeed = videos;
            showVideos(videos);
        },
        error: function () {
            document.getElementById('videoCarouselContainer').style.display = 'none';
            console.error('Error fetching videos');
        }
    });
}

window.VideoCarousel = {
    shimmer: function () {
        stopAllVideos();
        clearTimeout(videoDurationTimeout);
        clearTimeout(autoplayTimeout);
        videosLoaded = false;
        updateNavButtons();
        carousel.innerHTML = carouselShimmer;
    },
    restore: function () {
        if (window.videoFeed) showVideos(window.videoFeed);
    }
};

function updateNavButtons() {
    if (isMobile()) return;

    if (!videosLoaded || originalVideosCount === 0) {
        prevBtn.classList.remove('visible');
        nextBtn.classList.remove('visible');
        return;
    }

    const isRTL =
        document.documentElement.dir === 'rtl' ||
        window.getComputedStyle(document.body).direction === 'rtl';

    const maxScroll = carousel.scrollWidth - carousel.clientWidth;

    let logicalScroll;

    logicalScroll = carousel.scrollLeft;

    const canGoToStart = logicalScroll > 5;
    const canGoToEnd = logicalScroll < maxScroll - 5;

    prevBtn.classList.toggle('visible', canGoToStart);
    nextBtn.classList.toggle('visible', canGoToEnd);
}

function autoplayFirstVisibleCard() {
    // Find the first visible card
    var carouselRect = carousel.getBoundingClientRect();
    var firstVisibleCard = null;
    var allCards = carousel.querySelectorAll('.video-card');

    allCards.forEach(function (card) {
        var cardRect = card.getBoundingClientRect();
        if (cardRect.left < carouselRect.right && cardRect.right > carouselRect.left) {
            if (!firstVisibleCard) {
                firstVisibleCard = card;
            }
        }
    });

    if (firstVisibleCard && isPlaying(firstVisibleCard)) return;

    stopAllVideos();

    // Autoplay the first visible card
    if (firstVisibleCard) {
        playVideoCard(firstVisibleCard);
    }
}

function isPlaying(card) {
    var videoEl = card.querySelector('video');
    return card === currentlyPlayingCard && videoEl && !videoEl.paused;
}

function prepareVideo(videoEl, playWhenReady) {
    if (!videoEl.querySelector('source') && videoEl.dataset.src) {
        var source = document.createElement('source');
        source.src = videoEl.dataset.src;
        source.type = 'application/vnd.apple.mpegurl';
        videoEl.appendChild(source);
    }
    if (!playWhenReady) {
        videoEl.removeAttribute('data-play-when-ready');
    }
    PazarVideo.setup(videoEl, playWhenReady);
}

function playVideoCard(card) {
    var videoEl = card.querySelector('video');
    var imgEl = card.querySelector('.thumbnail-img');

    if (videoEl) {
        prepareVideo(videoEl, true);

        var nextIndex = (parseInt(card.getAttribute('data-video-index')) + 1) % originalVideosCount;
        var nextVideoEl = carousel.querySelector('[data-video-index="' + nextIndex + '"] video');
        if (nextVideoEl && nextVideoEl !== videoEl) {
            prepareVideo(nextVideoEl);
        }

        currentlyPlayingCard = card;
        videoEl.style.display = 'block';
        imgEl.style.display = 'none';
        videoEl.currentTime = 0;

        // Clear any pending autoplay timeouts
        clearTimeout(videoDurationTimeout);
        clearTimeout(autoplayTimeout);

        // Armed before play() because playback can start a moment later, once
        // the player has resolved the stream or fallen back to the original.
        var onVideoEnd = function() {
            videoEl.removeEventListener('ended', onVideoEnd);
            // Move to next video when current one finishes
            advanceToNextVideo();
        };

        videoEl.addEventListener('ended', onVideoEnd);

        // Maximum 10 seconds per video
        videoDurationTimeout = setTimeout(function() {
            videoEl.removeEventListener('ended', onVideoEnd);
            advanceToNextVideo();
        }, 10000);

        videoEl.play().catch(function() { });
    }
}

function advanceToNextVideo() {
    if (isUserInteracting) {
        return;
    }

    var allCards = carousel.querySelectorAll('.video-card');
    if (allCards.length === 0) return;

    var carouselRect = carousel.getBoundingClientRect();
    var currentFirstCard = null;

    // Find the currently visible card
    allCards.forEach(function (card) {
        var cardRect = card.getBoundingClientRect();
        if (cardRect.left < carouselRect.right && cardRect.right > carouselRect.left) {
            if (!currentFirstCard) {
                currentFirstCard = card;
            }
        }
    });

    if (!currentFirstCard) return;

    var currentIndex = parseInt(currentFirstCard.getAttribute('data-video-index'));
    var nextIndex = currentIndex + 1;

    // Loop back to the beginning
    if (nextIndex >= originalVideosCount) {
        nextIndex = 0;
    }

    var nextCard = carousel.querySelector('[data-video-index="' + nextIndex + '"]');

    if (nextCard) {
        // Scroll smoothly in the background without forcing into view
        carousel.scrollBy({
            left: 216,
            behavior: 'smooth'
        });

        // Play the next card
        setTimeout(function() {
            autoplayFirstVisibleCard();
        }, 300);
    }
}

const isRTL = document.documentElement.dir === 'rtl' ||
            window.getComputedStyle(document.body).direction === 'rtl';

prevBtn.addEventListener('click', function () {
    isUserInteracting = true;
    clearTimeout(autoplayTimeout);
    clearTimeout(videoDurationTimeout);

    const scrollDistance = isRTL ? 216 : -216;
    carousel.scrollBy({ left: scrollDistance, behavior: 'smooth' });
    setTimeout(function () {
        updateNavButtons();
        autoplayFirstVisibleCard();
        // Resume autoplay after a delay when user stops interacting
        autoplayTimeout = setTimeout(function() {
            isUserInteracting = false;
        }, 2000);
    }, 300);
});

nextBtn.addEventListener('click', function () {
    isUserInteracting = true;
    clearTimeout(autoplayTimeout);
    clearTimeout(videoDurationTimeout);

    const scrollDistance = isRTL ? -216 : 216;
    carousel.scrollBy({ left: scrollDistance, behavior: 'smooth' });
    setTimeout(function () {
        updateNavButtons();
        autoplayFirstVisibleCard();
        // Resume autoplay after a delay when user stops interacting
        autoplayTimeout = setTimeout(function() {
            isUserInteracting = false;
        }, 2000);
    }, 300);
});

carousel.addEventListener('scroll', function () {
    isUserInteracting = true;
    clearTimeout(autoplayTimeout);
    clearTimeout(videoDurationTimeout);

    updateNavButtons();

    // Clear existing timeout
    clearTimeout(scrollTimeout);

    // After scroll ends, autoplay the first visible card and resume auto-advance
    scrollTimeout = setTimeout(function () {
        autoplayFirstVisibleCard();
        // Resume autoplay after user stops scrolling
        autoplayTimeout = setTimeout(function() {
            isUserInteracting = false;
        }, 1000);
    }, 100);
});

carousel.addEventListener('click', function (e) {
    var card = e.target.closest('.video-card');
    if (card) {
        var adUrl = card.getAttribute('data-ad-url');
        if (adUrl && adUrl !== "#") {
            window.location.href = adUrl;
        }
    }
});

// Handle window resize
window.addEventListener('resize', function () {
    updateNavButtons();
});

// Stop autoplay when out of view
const carouselObserver = new IntersectionObserver(function (entries) {
    if (!entries[0].isIntersecting) {
        stopAllVideos();
        clearTimeout(videoDurationTimeout);
        clearTimeout(autoplayTimeout);
    } else if (!document.hidden) {
        autoplayFirstVisibleCard();
    }
});

carouselObserver.observe(document.getElementById('videoCarouselContainer'));

document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
        stopAllVideos();
        clearTimeout(videoDurationTimeout);
        clearTimeout(autoplayTimeout);
    }
});
